const companyFeaturesConstants = Object.freeze({
  ACCOUNTING_MODULE: 'accounting_module',
  BUDGETS_PO_AVAILABLE: 'budgets_po_available',
  PHYSICAL_CARD_AVAILABLE: 'physical_card_available',
  // Written by app-backend's `cli.py invoices sdi register-company` when a business registry
  // configuration is created on A-cube — not settable from the client, because it mirrors state
  // A-cube owns. `_enabled` rather than `_available`: every company CAN be connected, so
  // availability has no interesting answer; what varies is whether it has actually been wired up.
  SDI_ENABLED: 'sdi_enabled',
  TREEZOR_DISABLED: 'treezor_disabled',
  EXPENSES_DISABLED: 'expenses_disabled',
  SUBSCRIPTIONS_DISABLED: 'subscriptions_disabled',
  VENDORS_DISABLED: 'vendors_disabled',
  USE_CUSTOM_POLICIES: 'use_custom_policies',
  COST_CENTER_TAG_IS_MANDATORY: 'cost_center_tag_is_mandatory',
  EXPENSE_TAG_IS_MANDATORY: 'expense_tag_is_mandatory',
  TEAM_TAG_IS_MANDATORY: 'team_tag_is_mandatory',
  PROJECT_TAG_IS_MANDATORY: 'project_tag_is_mandatory',
  LOCATION_TAG_IS_MANDATORY: 'location_tag_is_mandatory',
  GENERIC_EXPENSE_TAG_IS_MANDATORY: 'generic_expense_tag_is_mandatory',
  INVOICE_TAG_IS_MANDATORY: 'invoice_tag_is_mandatory',
  MILEAGE_EXPENSES_IS_ACTIVE: 'mileage_expenses_is_active',
  PSD2_OB_AVAILABLE: 'psd2_ob_available',
  ICP_TIER: 'icp_tier',
  EXPENSE_AGENT_AVAILABLE: 'expense_agent_available',
});

const companySettingsConstants = Object.freeze({
  EXPENSES_PLAN: 'expenses_plan',
});

// Page size for pagination
const DEFAULT_PAGE_SIZE = 25;

const DEFAULT_TABLE_DATA = {
  loaded: false,
  loadedPages: 1,
  pagination: null,
  page: 1,
  pageCursors: {},
  rows: []
}

const DEFAULT_TABLE_QUERY = {
  order_by: '-name',
  per_page: DEFAULT_PAGE_SIZE,
}

const DEFAULT_MODAL_PROPS = { loading: false, open: false };

const systemHashKeysConstants = Object.freeze({
  ADD_MULTIPLE_SUBSCRIPTIONS: '#add-multiple-subscriptions',
  ADD_SINGLE_SUBSCRIPTION: '#add-single-subscription',
  ENABLE_WS: '#enable-ws',
  OPEN_BANK_ACCOUNT_DETAILS: '#open-bank-account-popup',
  TRANSACTIONS_INVOICE_MISSING: '#transactions-invoice-missing',
  UNMATCHED_INVOICES: '#unmatched-invoices'
});

const popupSettingsConstants = Object.freeze({
  TRANSACTIONS_INVOICE_MISSING: 'transactions_invoice_missing',
  UNMATCHED_INVOICES: 'unmatched_invoices',
});

const agentTypeConstants = Object.freeze({
  ADD_NEW_BUDGET: 'add_new_budget',
  ADD_NEW_EXPENSE: 'add_new_expense',
  EXPENSE_ANALYSIS: 'expense_analysis',
  FILL_MISSING_INFO: 'fill_missing_info',
  MILEAGE_EXPENSE_SUBMISSION: 'mileage_expense_submission',
});

const tagUsageConstants = Object.freeze({
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
  NOT_USED: 'not_used',
});

const icpTierConstants = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
});

// Animation duration (in milliseconds)
const SYSTEM_ANIMATION_DURATION = 300;

export {
  companyFeaturesConstants,
  companySettingsConstants,
  DEFAULT_MODAL_PROPS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_TABLE_DATA,
  DEFAULT_TABLE_QUERY,
  popupSettingsConstants,
  systemHashKeysConstants,
  SYSTEM_ANIMATION_DURATION,
  agentTypeConstants,
  tagUsageConstants,
  icpTierConstants,
};
